import { keepPreviousData, useQuery } from "@tanstack/react-query";
import StreamsStore from "stores/streams/StreamsStore";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
export const KEY_PREFIX = ["streams", "overview"];
export const keyFn = (searchParams) => [...KEY_PREFIX, searchParams];
export const fetchStreams = (searchParams) => StreamsStore.searchPaginated(searchParams.page, searchParams.pageSize, searchParams.query, {
  sort: searchParams == null ? void 0 : searchParams.sort.attributeId,
  order: searchParams == null ? void 0 : searchParams.sort.direction,
  filters: FiltersForQueryParams(searchParams.filters)
});
const useStreams = (searchParams, { enabled } = { enabled: true }) => {
  const { data, refetch, isInitialLoading } = useQuery({
    queryKey: keyFn(searchParams),
    queryFn: () => defaultOnError(
      fetchStreams(searchParams),
      "Loading streams failed with status",
      "Could not load streams"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    refetch,
    isInitialLoading
  };
};
export default useStreams;
